import * as React from "react";
import { Button, Modal } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { HealthSurveillanceReviewForm } from "../../../healthSurveillance/review";
import { ReadonlyHealthSurveillanceReviewForm } from "../../../healthSurveillance/review/components/ReadonlyHealthSurveillanceReviewForm";

export const ReviewHealthSurveillanceResultsButton: React.FunctionComponent<{ task: TaskModel }> = (props) => {
    const [modalOpen, setModalOpen] = React.useState(false);

    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    if (props.task.cancelled) {
        return null;
    }

    if (props.task.completed) {
        return (
            <>
                <Button content="View HS Results Form" floated="right" onClick={openModal} />
                {modalOpen &&
                    <Modal
                        header="Review HS Results"
                        content={
                            <ReadonlyHealthSurveillanceReviewForm
                                customerId={props.task.customer.id}
                                ohCaseId={props.task.caseId}
                                onClose={closeModal}
                            />
                        }
                        onActionClick={closeModal}
                        open={modalOpen}
                    />}
            </>
        );
    }

    return (
        <>
            <Button content="Start" floated="right" onClick={openModal} />
            {modalOpen &&
                <Modal
                    header="Review HS Results"
                    content={
                        <HealthSurveillanceReviewForm
                            customerId={props.task.customer.id}
                            ohCaseId={props.task.caseId}
                            taskId={props.task.id}
                            onClose={closeModal}
                        />
                    }
                    onActionClick={closeModal}
                    open={modalOpen}
                />}
        </>
    );
};
